import * as React from "react";
import { style, keyframes, classes } from "typestyle";
import { connect } from "react-redux";
import { IStoreState, getGeolocationState } from "../../../redux/rootReducer";
import {
  IGeolocationState,
  STATE_PENDING,
  STATE_INACTIVE,
  STATE_WATCHING,
  STATE_CHASING,
  STATE_ERROR,
} from "../../../redux/modules/geolocation/reducer";
import { IGcpAppDispatchProp } from "../../../redux/store";
import { userClicksGeolocationButton } from "./scenarios";
import { Blue80 } from "@traceair/tds";

interface IProps extends IGcpAppDispatchProp {
  geolocationState: IGeolocationState;
}
class GeolocationButton extends React.Component<IProps> {
  public render() {
    const { stateStatus } = this.props.geolocationState;
    const isChasing = stateStatus === STATE_CHASING;
    return (
      <div
        className={classes(
          "geolocation-button",
          style({
            pointerEvents: "auto",
            cursor: "pointer",
            background: isChasing ? Blue80 : "#FFFFFF",
            padding: "8px",
            borderRadius: "8px",
            boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            width: "24px",
            height: "24px",
          }),
        )}
        onClick={this.handleClick}
      >
        {this.renderIcon()}
      </div>
    );
  }

  private renderIcon() {
    const { stateStatus } = this.props.geolocationState;
    switch (stateStatus) {
      case STATE_INACTIVE:
        return <img src="icon-geolocation.svg" />;
      case STATE_PENDING:
        return <GeolocationThrobber />;
      case STATE_WATCHING:
        return <img src="icon-geolocation-active.svg" />;
      case STATE_CHASING:
        return <img src="icon-geolocation-chasing.svg" />;
      case STATE_ERROR:
        return <img src="icon-geolocation-error.svg" />;
      default:
        throw new Error("Unexpected Geolocation Button State");
    }
  }

  private handleClick = (ev: React.MouseEvent<any>) => {
    ev.stopPropagation();
    this.props.dispatch(userClicksGeolocationButton());
  };
}

export default connect((state: IStoreState) => ({
  geolocationState: getGeolocationState(state),
}))(GeolocationButton);

const GeolocationThrobber = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" className={svgCN}>
    <g
      id="ic/loading"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="bound" points="24 0 0 0 0 24 24 24"></polygon>
      <g id="Group" transform="translate(2.000000, 2.000000)" strokeWidth="2">
        <path
          d="M20,20 C20,14.4771525 15.5228475,10 10,10"
          id="Oval-4"
          stroke="#A5A5A5"
          transform="translate(15.000000, 15.000000) rotate(-270.000000) translate(-15.000000, -15.000000) "
        ></path>
        <path
          d="M20,10 C20,4.4771525 15.5228475,0 10,0"
          id="Oval-4-Copy-2"
          stroke="#DDDDDD"
          transform="translate(15.000000, 5.000000) rotate(-360.000000) translate(-15.000000, -5.000000) "
        ></path>
        <path
          d="M0,20 C5.5228475,20 10,15.5228475 10,10"
          id="Oval-4-Copy"
          stroke="#000000"
          transform="translate(5.000000, 15.000000) rotate(-270.000000) translate(-5.000000, -15.000000) "
        ></path>
      </g>
    </g>
  </svg>
);

const rotateAnimationName = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "25%": { transform: "rotate(90deg)" },
  "50%": { transform: "rotate(180deg)" },
  "75%": { transform: "rotate(270deg)" },
  "100%": { transform: "rotate(360deg)" },
});

const svgCN = style({
  animationName: rotateAnimationName,
  animationDuration: "1s",
  animationIterationCount: "infinite",
  animationTimingFunction: "linear",
});
